import React, { Component } from 'react';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from '../../../custom/FormicaSearchSelectBox';
import { RootState } from '../../../../redux/store';
import { VelocityVariableState } from '../../../../redux/reducers/VelocityVariableReducer';
import { enterComponent, leaveComponent } from '../../../../redux/actions/ComponentActions';
import { changeVelocityVariable, changeVelocityVariableIsUpdate, clearVelocityVariable } from '../../../../redux/actions/VelocityVariableActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import RoleHelper from '../../../../RoleHelper';
import TimePickerContainer from '../../../custom/custom-time-picker/TimePickerContainer';
import { FormicaTimePickerDate } from '../../../custom/custom-time-picker/TimePickerDomain';
import moment from 'moment';
import MessageUtil from '../../../../util/MessageUtil';
import ComponentName from '../../../../constant/ComponentName';
import LanguageUtil from '../../../../util/LanguageUtil';

class VelocityVariableTestComponent extends Component<Props> {
  public render() {
    const {
      velocityVariable: { velocityVariable },
    } = this.props;
    return (
      <div className={'flex w-full gap-x-5'}>
        <div className={'flex items-center w-full'}>
          <FormicaSearchSelectBox
            options={this.getFunctionOptions()}
            onChange={(e: FormicaSelectBoxItem) => {
              this.onChangeFunction(e);
            }}
            icon={velocityVariable.function}
            disabled={!RoleHelper.canEdit('EnrichmentVelocity')}
            value={velocityVariable.function}
            rounded
            data-testid={`${ComponentName.VELOCITY}_function_select`}
          />
        </div>
        <div className={'flex items-center w-full'}>
          <TimePickerContainer
            startDate={velocityVariable.startDate}
            endDate={velocityVariable.endDate}
            onChangeEndDate={this.onChangeEndDate}
            onChangeStartDate={this.onChangeStartDate}
            roundVisible
            data-testid={`${ComponentName.VELOCITY}_date_picker`}
          />
        </div>
      </div>
    );
  }

  private onChangeFunction = (e: FormicaSelectBoxItem) => {
    const {
      velocityVariable: { velocityVariable },
      changeVelocityVariable,
    } = this.props;
    velocityVariable.function = e.value;
    changeVelocityVariable(velocityVariable);
  };

  private onChangeStartDate = (date: FormicaTimePickerDate) => {
    const {
      velocityVariable: { velocityVariable },
      changeVelocityVariable,
    } = this.props;
    if (!RoleHelper.canEdit('EnrichmentVelocity')) return;
    const fiveYearsAgo = moment().subtract(5, 'years').valueOf();
    if (date.value instanceof Date) {
      if (date.value.valueOf() < fiveYearsAgo - 200) {
        MessageUtil.error({
          summary: 'Date cannot be more than 5 years ago',
        });
        return;
      }
    }
    velocityVariable.startDate = date;
    changeVelocityVariable(velocityVariable);
  };

  private onChangeEndDate = (date: FormicaTimePickerDate) => {
    const {
      velocityVariable: { velocityVariable },
      changeVelocityVariable,
    } = this.props;
    if (!RoleHelper.canEdit('EnrichmentVelocity')) return;
    velocityVariable.endDate = date;
    changeVelocityVariable(velocityVariable);
  };

  private getFunctionOptions = (): FormicaSelectBoxItem[] => {
    return [
      {
        label: LanguageUtil.get({ id: 'common.aggregations.average', defaultMessage: 'Average' }),
        value: 'average',
        icon: 'average',
      },
      {
        label: LanguageUtil.get({ id: 'common.aggregations.sum', defaultMessage: 'Sum' }),
        value: 'sum',
        icon: 'function_sum',
      },
      {
        label: LanguageUtil.get({ id: 'common.aggregations.count', defaultMessage: 'Count' }),
        value: 'count',
        icon: 'count',
      },
      {
        label: LanguageUtil.get({ id: 'common.aggregations.minimum', defaultMessage: 'minimum' }),
        value: 'minimum',
        icon: 'minimum',
      },
      {
        label: LanguageUtil.get({ id: 'common.aggregations.maximum', defaultMessage: 'Maximum' }),
        value: 'maximum',
        icon: 'maximum',
      },
      {
        label: LanguageUtil.get({ id: 'common.aggregations.distinct', defaultMessage: 'Distinct' }),
        value: 'distinct',
        icon: 'distinct',
      },
      {
        label: LanguageUtil.get({ id: 'common.aggregations.mode', defaultMessage: 'Mode' }),
        value: 'mode',
        icon: 'mode',
      },
      {
        label: LanguageUtil.get({ id: 'common.aggregations.anti_mode', defaultMessage: 'Anti Mode' }),
        value: 'anti_mode',
        icon: 'anti_mode',
      },
    ];
  };
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  velocityVariable: state.velocityVariable as VelocityVariableState,
});

const mapDispatchToProps = {
  enterComponent,
  leaveComponent,
  changeVelocityVariable: changeVelocityVariable,
  clearAggregationVariable: clearVelocityVariable,
  changeVelocityVariableIsUpdate: changeVelocityVariableIsUpdate,
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(VelocityVariableTestComponent);
